import React, { useEffect } from 'react';
import { useGym } from '../../DataStore/Gym/GymContext';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import functions from '../../util/functions';

const TrainerCommissionBalances = ({onPay}) => {
  const { getCommissionBalances, commissionBalances } = useGym();

  useEffect(() => {
    getCommissionBalances();
  }, []);

  const handlePayCommission = (trainer) => {
    onPay(trainer);
  };

  return (
    <div className="main-card mb-3 card">
      <div className="card-header card-title">
        Outstanding Commission
        <div className="btn-actions-pane-right actions-icon-btn"></div>
      </div>

      <div className="card-body" style={{ maxHeight: '300px', overflowY: 'auto' }}>
        {Array.isArray(commissionBalances) && commissionBalances.length > 0 ? (
          <div className="scrollbar-container ps">
            <ul className="rm-list-borders rm-list-borders-scroll list-group list-group-flush">
              {commissionBalances.map((trainer) => (
                <li className="list-group-item" key={trainer.id}>
                  <div className="widget-content p-0">
                    <div className="widget-content-wrapper">
                      <div className="widget-content-left mr-3">
                        <img
                          width="38"
                          alt='Trainer'
                          className="rounded-circle"
                          src={trainer.photo || 'assets/images/avatars/default.png'}
                        />
                      </div>
                      <div className="widget-content-left">
                        <div className="widget-heading">{trainer.full_name}</div>
                        <div className="widget-subheading">
                            {trainer.phone_number || 'No phone'}
                        </div>
                      </div>
                      <div className="widget-content-right text-right">
                        <div className="fsize-1 text-focus">
                          <small className="opacity-5 pr-1">UGX</small>
                          <span>{functions.numberFormat(trainer.commission_balance)}</span>
                          <small className="text-success pl-2">
                            <i className="fa fa-angle-up"></i>
                          </small>
                        </div>
                        <button
                          className="mt-2 btn btn-sm btn-primary"
                          onClick={() => handlePayCommission(trainer)}
                        >
                          Pay Trainer
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ) : commissionBalances === "404" ? (
          <Notification message="No outstanding trainer commission found." closable={false} />
        ) : (
          <ActivityLoader />
        )}
      </div>
    </div>
  );
};

export default TrainerCommissionBalances;
